import React, { useEffect, useState } from 'react';
import Widget from '../../../components/Widget';
import FuelConsumptionBarLineChart from '../../../components/Chart/FuelConsumptionBarLine';
import PeriodSelector from './PeriodSelector';
import MovementChart from '../../../components/Chart/MovementChart';

function DeviceMovement(props) {

    return (
        <Widget>
            {/* <PeriodSelector handleDataGroup={props.handleDataGroup} selectedGroup={props.selectedGroup} handlePeriodChange={props.handlePeriodChange}
                selectedValue={props.selectedValue} callFuelData={props.callFuelData} device={props.device} loading={props.loading} /> */}
            <MovementChart
                selectedGroup={props.selectedGroup}
                loading={props.loading}
                assetData={props.assetData}
                data={props.data}
                rawData={props.rawData}
            />
        </Widget>
    );
}

export default DeviceMovement;
